/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPMIMETYPE } from './IAPMIMETYPE';
import {
    IAPMIMETYPEFromJSON,
    IAPMIMETYPEFromJSONTyped,
    IAPMIMETYPEToJSON,
} from './IAPMIMETYPE';

/**
 * 
 * @export
 * @interface SingleDocumentResponseViewModel
 */
export interface SingleDocumentResponseViewModel {
    /**
     * 
     * @type {string}
     * @memberof SingleDocumentResponseViewModel
     */
    contentManagerItemId: string;
    /**
     * 
     * @type {string}
     * @memberof SingleDocumentResponseViewModel
     */
    fileName: string;
    /**
     * 
     * @type {IAPMIMETYPE}
     * @memberof SingleDocumentResponseViewModel
     */
    mimeType: IAPMIMETYPE;
}

/**
 * Check if a given object implements the SingleDocumentResponseViewModel interface.
 */
export function instanceOfSingleDocumentResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contentManagerItemId" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "mimeType" in value;

    return isInstance;
}

export function SingleDocumentResponseViewModelFromJSON(json: any): SingleDocumentResponseViewModel {
    return SingleDocumentResponseViewModelFromJSONTyped(json, false);
}

export function SingleDocumentResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleDocumentResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contentManagerItemId': json['ContentManagerItemId'],
        'fileName': json['FileName'],
        'mimeType': IAPMIMETYPEFromJSON(json['MimeType']),
    };
}

export function SingleDocumentResponseViewModelToJSON(value?: SingleDocumentResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ContentManagerItemId': value.contentManagerItemId,
        'FileName': value.fileName,
        'MimeType': IAPMIMETYPEToJSON(value.mimeType),
    };
}

